import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, BookOpen, ShoppingCart, DollarSign } from "lucide-react";
import { Button } from "@/components/ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${API}/admin/dashboard`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStats(response.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="flex items-center justify-center py-20">
          <div className="w-16 h-16 border-4 border-[#0f3e3e] border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="admin-dashboard">
      <Navbar />

      <section className="py-20 md:py-32 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight text-[#0f3e3e] mb-12" data-testid="admin-dashboard-title">
            Admin Dashboard
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <Card className="border-[#0f3e3e]/20">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium">Total Users</CardTitle>
                <Users className="h-4 w-4 text-[#0f3e3e]" />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-[#0f3e3e]" data-testid="total-users">
                  {stats?.total_users || 0}
                </div>
              </CardContent>
            </Card>

            <Card className="border-[#0f3e3e]/20">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium">Total Courses</CardTitle>
                <BookOpen className="h-4 w-4 text-[#0f3e3e]" />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-[#0f3e3e]" data-testid="total-courses">
                  {stats?.total_courses || 0}
                </div>
              </CardContent>
            </Card>

            <Card className="border-[#0f3e3e]/20">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium">Total Purchases</CardTitle>
                <ShoppingCart className="h-4 w-4 text-[#0f3e3e]" />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-[#0f3e3e]" data-testid="total-purchases">
                  {stats?.total_purchases || 0}
                </div>
              </CardContent>
            </Card>

            <Card className="border-[#0f3e3e]/20">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium">Total Revenue</CardTitle>
                <DollarSign className="h-4 w-4 text-[#0f3e3e]" />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold text-[#0f3e3e]" data-testid="total-revenue">
                  ₹{stats?.total_revenue || 0}
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Link to="/admin/courses">
              <Button className="w-full h-24 bg-[#0f3e3e] text-white hover:bg-[#0f3e3e]/90 text-lg" data-testid="manage-courses-btn">
                <BookOpen className="mr-2 h-6 w-6" />
                Manage Courses
              </Button>
            </Link>

            <Link to="/admin/users">
              <Button className="w-full h-24 bg-[#0f3e3e] text-white hover:bg-[#0f3e3e]/90 text-lg" data-testid="manage-users-btn">
                <Users className="mr-2 h-6 w-6" />
                Manage Users
              </Button>
            </Link>

            <Link to="/admin/purchases">
              <Button className="w-full h-24 bg-[#0f3e3e] text-white hover:bg-[#0f3e3e]/90 text-lg" data-testid="view-purchases-btn">
                <ShoppingCart className="mr-2 h-6 w-6" />
                View Purchases
              </Button>
            </Link>

            <Link to="/admin/certificates">
              <Button className="w-full h-24 bg-[#0f3e3e] text-white hover:bg-[#0f3e3e]/90 text-lg" data-testid="view-certificates-btn">
                <ShoppingCart className="mr-2 h-6 w-6" />
                View Certificates
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
